export default __webpack_public_path__ + "static/media/conecta-gabinete.8f7f579e.png";